<template>
  <div>
    <h4 v-show="!cargando" class="text-center"> Inscripciones mes de <b>{{getMes()}}</b> </h4>
    <router-link v-show="!cargando" to="/" title="Titulo"> 
    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-chevron-double-left" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
    <path fill-rule="evenodd" d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
    </svg>
    Volver a la sede 
    </router-link>
    <div v-show="cargando" class="loader-spin" style="margin: 0 auto;"></div>

    <div class="row">
        <div :key="ind" v-for="(sede,ind) in sedesall" class="col-sm-4">
            <p class="text-center text-primary" style="margin-bottom:0;margin-top:0"> <b>{{sede.nombre}}</b> </p>
            <div class="row">
                <div :key="ind2" v-for="(ase,ind2) in sede.asesores" class="col-sm-4 col-lg-3" :title="getTitle(ase)">
                    <img :src="ase.info.foto" alt="" class="img-responsive fotito2" style="width: 100px; height: 100px;">
                    <img v-if="ind2==0" src="img/aaa.png" alt="" class="medallita">
                    <img v-else-if="ind2==1" src="img/bbb.png" alt="" class="medallita">
                    <img v-else src="img/ccc.png" alt="" class="medallita">
                    <p class="text-center " style="margin-bottom:0"> <small>{{ase.info.nombre}}</small> </p>
                    <p class="text-center" style="margin-top:0"> <b>{{ase.total}}</b> </p>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>


<style lang="css">
.medallita{
  width: 20px;
  position: absolute;
  right: 10px;
  top: 15px;
}
.fotito2{
  padding:2px;
  border-radius:50%;
  border:1px solid #012C5C
}
.loader-spin {
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid blue; /* Blue */
  border-bottom: 4px solid blue;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1.2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>



<script>
import gql from 'graphql-tag'
export default {
  components: {},
  data() {
    return {
      location_user_pick: process.env.VUE_APP_URL_USERPICK,
      cargando:true,
      sedesall:[],
      total: 0,
      letters : [],
      value: 0,
    };
  },
  watch:{},
  methods:{
      getMes(){
          var date = new Date();
          var m = date.getMonth();
          if( m == 0 ) return 'Enero';
          else if( m == 9 ) return 'Octubre';
          else if( m == 10 ) return 'Noviembre';
          else if( m == 11 ) return 'Diciembre';
      },
      getTitle( user ){
        var ps = user.dip+user.maes+user.esp;
        var t = `Programas: ${ps}, Cursos: ${user.cur}`;
        return t;
      },
      getNextLetter() {
        if (this.letters.length === 0) {
          // Genera las letras de A a Z
          for (let i = 0; i < 26; i++) {
            this.letters.push(String.fromCharCode(65 + i));
          }
        }

        let letter = this.letters[this.value % 26];
        if (this.value >= 26) {
          // Si ya hemos usado todas las letras de A a Z, agregamos una segunda letra
          letter += this.letters[Math.floor(this.value / 26) - 1];
        }

        this.value++;
        return letter;
      },
      getsedes(){
          this.cargando = true;
          this.primero = {info:{}};
          this.segundo = {info:{}};
          this.tercero = {info:{}};
          this.cargando = true;
          var date = new Date();
          var m = date.getMonth()+1;
          var d = date.getDate();
          var a = date.getFullYear();
          if( d == 1 ) d +=1;
          if( m < 10 ) m = '0'+m;
          if( d < 10 ) d = '0'+d;
          let ini = a+'-'+m+'-01';
          let fin = a+'-'+m+'-'+d;
          let sql = gql`query{ getSedes(estado:true){id,nombre} }`;
          let xsql = '';
          const vue = this;

          this.$apollo.mutate({
            mutation: sql,
          }).then((data) => {
            let sedes = data.data.getSedes; 
            sedes.forEach(function(e){
                // let letter = (value + 9).toString(36).toUpperCase();
                let letter = vue.getNextLetter();
                xsql += `${letter}:getInscripcionesBySede(sede:${e.id},fechas:{fecha_ini:"${ini}",fecha_fin:"${fin}"}){ id,estado_ins,asesor{id,nombres,pri_apellido,seg_apellido,usuario{foto}},programa{id,sede{id,nombre},postgrado{id,nombre,categoria{id,nombre}}} }  \n\n`
            });
            let xsq = gql`query{${xsql}}`;
            window.console.log( xsq );
            this.getinscritos( xsq );
          }).catch((error) => {
            window.console.error(error);
          })
      },
      getinscritos( sql ){
          var sedes = [];
          var vue = this;
          this.$apollo.mutate({
            mutation: sql,
          }).then((data) => {
            var da = data.data;
            const pares = Object.entries(da);
            pares.forEach(function(e){
                var ins = e[1];
                ins = ins.filter(function(e){ 
                  if( e.programa.sede.id == 2 ){ // excluimos formacion continua
                    var fc = [5071,72,5281,8382]
                    return e.estado_ins > 0 && !fc.includes(e.asesor.id); // quitar ! para listar solo fc ;)
                  }else{
                    return e.estado_ins > 0
                  }
                });
                var sede;
                ins.forEach( function(e){
                    //window.console.log( e )
                    var nom = e.asesor.nombres+' '+e.asesor.pri_apellido;
                    sede = sedes.find( x => x.id == e.programa.sede.id );
                    if( !sede ) {
                        sedes.push( {id:e.programa.sede.id,nombre:e.programa.sede.nombre,asesores:[],total:0} );
                        sede = sedes.find( x => x.id == e.programa.sede.id );
                        //window.console.log( '>SEDE: ',sede )
                    }

                    var ase = sede.asesores.find( x => x.info.id == e.asesor.id );
                    if( !ase ) {
                        var img;
                        if( e.asesor.usuario.foto && e.asesor.usuario.foto.includes('.') ) img = vue.location_user_pick+''+e.asesor.usuario.foto;
                        else img = vue.location_user_pick+'userdefault.png';
                        sede.asesores.push( {info:{id:e.asesor.id,nombre:nom,foto:img},dip:0,maes:0,esp:0,cur:0} );
                    }
                    ase = sede.asesores.find( x => x.info.id == e.asesor.id );
                    if( e.programa.postgrado.categoria.id == 1 ) ase.dip += 1;
                    else if( e.programa.postgrado.categoria.id == 2 ) ase.esp += 1;
                    else if( e.programa.postgrado.categoria.id == 3 ) ase.maes += 1;
                    else ase.cur += 1;
                    ase.total = ase.dip+ase.esp+ase.maes+ase.cur;
                    sede.total += ase.total;
                });

                if( sede ){
                    sede.asesores.sort( function(a,b){
                        if( a.total > b.total ) return -1;
                        if( a.total < b.total ) return 1;
                        return 0;
                    });
                    sede.asesores = sede.asesores.slice(0,3);
                }

            });

            this.sedesall = sedes;
            window.console.log( 'SEDES:',sedes );
            this.cargando = false;
          }).catch((error) => {
            window.console.error(error);
            vue.cargando = false;
          })
      },
  },
  mounted() {
      this.getsedes();
  },
};
</script>
